import { useRef, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import FormHelperText from '@mui/material/FormHelperText'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import DeleteIcon from '@mui/icons-material/Delete'
import { adminUploadImage } from '../../api/admin'

export default function ImageUploader ({ label = 'Event image', value, onChange, hint }) {
  const inputRef = useRef(null)
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState(null)

  const handleFile = async (event) => {
    const file = event.target.files?.[0]
    event.target.value = ''
    if (!file) return
    setUploading(true)
    setError(null)
    try {
      const result = await adminUploadImage(file)
      onChange(result.url)
    } catch (err) {
      setError(err.message)
    } finally {
      setUploading(false)
    }
  }

  return (
    <Box>
      {label && <Typography variant='subtitle2' sx={{ mb: 1 }}>{label}</Typography>}
      {value && (
        <Box sx={{ mb: 1 }}>
          <Box
            component='img'
            src={value}
            alt={label}
            sx={{
              width: 420,
              maxWidth: '100%',
              display: 'block',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider'
            }}
          />
        </Box>
      )}
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <input ref={inputRef} type='file' accept='image/*' hidden onChange={handleFile} />
        <Button
          size='small'
          variant='outlined'
          startIcon={uploading ? <CircularProgress size={16} /> : <CloudUploadIcon />}
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
        >
          {uploading ? 'Uploading…' : value ? 'Replace image' : 'Upload image'}
        </Button>
        {value && (
          <Button size='small' color='error' startIcon={<DeleteIcon />} onClick={() => onChange('')}>
            Remove
          </Button>
        )}
      </Box>
      {hint && <FormHelperText sx={{ mt: 1 }}>{hint}</FormHelperText>}
      {error && <Alert severity='error' sx={{ mt: 1 }}>{error}</Alert>}
    </Box>
  )
}
